export default {
	casasDecimais: {
		quantidade: 2,
	},
	integracao: {
		camunda: {
			processKey: null,
		},
	},
}
